<template>
  <div
    v-click-outside="emitClose"
    :class="containerClasses"
    data-walkthrough-id="dropdown-periodpicker"
    @click.prevent.stop="doNothing"
  >
    <PeriodPickerYearsWithPeriods
      v-if="showPeriodsWithYears"
      :current-ledger-id="currentLedgerId"
      :highlighted-period="highlightedPeriod"
      :highlighted-year="highlightedYear"
      :ledgers-per-year="ledgersPerYear"
      :years="years"
      :new-layout="newLayout"
      @period-click="openPeriod"
    />
    <PeriodPickerYears
      v-else
      :years="years"
      :highlighted-year="highlightedYear"
      :new-layout="newLayout"
      @year-click="openYear"
    />
  </div>
</template>

<script>
import PeriodPickerYearsWithPeriods from './period-picker-years-with-periods'
import PeriodPickerYears from './period-picker-years'

export default {
  components: {
    PeriodPickerYearsWithPeriods,
    PeriodPickerYears,
  },
  props: {
    years: {
      type: Array,
      required: true,
    },
    ledgersPerYear: {
      type: Number,
      default: 12,
    },
    currentLedgerId: {
      type: Number,
      default: null,
    },
    newLayout: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-compare-period', 'close-period-picker'],
  computed: {
    allPeriods() {
      return this.years.flatMap((year) => year.periods)
    },
    containerClasses() {
      if (this.newLayout) {
        return [
          'periodpicker-new-layout',
          'tw-block',
          'tw-bg-white',
          'tw-rounded-lg',
          'tw-shadow-lg',
          'tw-border',
          'tw-border-solid',
          'tw-border-sf-slate-lighter-2',
          'tw-w-full',
          'tw-mt-1',
          'tw-text-center',
          'tw-cursor-default',
        ]
      }
      return ['periodpicker', 'periodpicker-inline']
    },
    highlightedPeriod() {
      return this.allPeriods.find(
        (period) => this.currentLedgerId === period.ledgerId
      )
    },
    highlightedYear() {
      return this.years.find(
        (year) =>
          year.periods.find(
            (period) => period.ledgerId === this.currentLedgerId
          ) !== undefined
      )
    },
    showPeriodsWithYears() {
      return this.ledgersPerYear !== 1
    },
  },
  methods: {
    doNothing() {
      // intentionally left blank
    },
    triggerChangePeriod(ledgerId) {
      this.$emit('change-compare-period', ledgerId)
    },
    openPeriod({ period }) {
      this.triggerChangePeriod(period.ledgerId)
    },
    openYear({ year }) {
      if (year.periods.length) {
        this.triggerChangePeriod(year.periods[0].ledgerId)
      }
    },
    emitClose() {
      this.$emit('close-period-picker')
    },
  },
}
</script>
